var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.812,
    height: 27.812,
    viewBox: "0 0 27.812 27.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 27.812,
    height: 27.812,
    fill: "#52cb3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M17.271,15.826a1.281,1.281,0,1,0-1.909,1.708L20.6,23.2a1.259,1.259,0,0,0,1.809,0L35.5,10.109a1.258,1.258,0,0,0,0-1.809,1.288,1.288,0,0,0-1.809,0L21.556,20.432Z",
    transform: "translate(-8.584 -4.526)",
    fill: "#52cb3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M26.524,12.618a1.289,1.289,0,0,0-1.288,1.288A11.331,11.331,0,1,1,13.906,2.575a1.288,1.288,0,0,0,0-2.575A13.906,13.906,0,1,0,27.812,13.906a1.289,1.289,0,0,0-1.288-1.288",
    transform: "translate(0 0)",
    fill: "#52cb3c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/green-tick-circle.30e4397fd922c20bdb7e7728308d3b86.svg";
export { ForwardRef as ReactComponent };